export default {
  INVESTOR_PROFILE_INVESTMENT_EXPERIENCE_REPOSITORY: Symbol.for('INVESTOR_PROFILE_INVESTMENT_EXPERIENCE_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_INVESTMENT_EXPERIENCE_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_INVESTMENT_EXPERIENCE_COMMAND'),
};
